<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
    /**
     * Number of successful items.
     * @default 0
     * @type {Number}
     */
    success: {
        type: Number,
        default: 0
    },
    /**
     * Number of warning items.
     * @default 0
     * @type {Number}
     */
    warning: {
        type: Number,
        default: 0
    },
    /**
     * Number of error items.
     * @default 0
     * @type {Number}
     */
    error: {
        type: Number,
        default: 0
    },
    /**
     * Show wait cursor, otherwise the default cursor.
     * @default false
     * @type {Boolean}
     */
    showWait: {
        type: Boolean,
        default: false
    },
    /**
     * Total number of items.
     * @default 100
     */
    total: {
        type: Number,
        default: 100
    }
});

const progressSuccess = computed(() => (props.success / props.total) * 100);

const progressWarning = computed(() => (props.warning / props.total) * 100);

const progressError = computed(() => (props.error / props.total) * 100);
</script>

<template>
    <div class="sy-progress-bar multi" :class="{ 'sy-wait' : showWait }">
        <div :style="`width:${progressSuccess}%`" class="success" :class="{ 'sy-wait' : showWait }"></div>
        <div :style="`width:${progressWarning}%`" class="warning" :class="{ 'sy-wait' : showWait }"></div>
        <div :style="`width:${progressError}%`" class="error" :class="{ 'sy-wait' : showWait }"></div>
    </div>
</template>
